module.exports = require("./doi.d.ts");